const MimeDb = {
  "image/aces": {
    source: "iana",
    extensions: ["exr"],
  },
  "image/apng": {
    compressible: false,
    extensions: ["apng"],
  },
  "image/avci": {
    source: "iana",
  },
  "image/avcs": {
    source: "iana",
  },
  "image/bmp": {
    source: "iana",
    compressible: true,
    extensions: ["bmp"],
  },
  "image/cgm": {
    source: "iana",
    extensions: ["cgm"],
  },
  "image/dicom-rle": {
    source: "iana",
    extensions: ["drle"],
  },
  "image/emf": {
    source: "iana",
    extensions: ["emf"],
  },
  "image/fits": {
    source: "iana",
    extensions: ["fits"],
  },
  "image/g3fax": {
    source: "iana",
    extensions: ["g3"],
  },
  "image/gif": {
    source: "iana",
    compressible: false,
    extensions: ["gif"],
  },
  "image/heic": {
    source: "iana",
    extensions: ["heic"],
  },
  "image/heic-sequence": {
    source: "iana",
    extensions: ["heics"],
  },
  "image/heif": {
    source: "iana",
    extensions: ["heif"],
  },
  "image/heif-sequence": {
    source: "iana",
    extensions: ["heifs"],
  },
  "image/hej2k": {
    source: "iana",
    extensions: ["hej2"],
  },
  "image/hsj2": {
    source: "iana",
    extensions: ["hsj2"],
  },
  "image/ief": {
    source: "iana",
    extensions: ["ief"],
  },
  "image/jls": {
    source: "iana",
    extensions: ["jls"],
  },
  "image/jp2": {
    source: "iana",
    compressible: false,
    extensions: ["jp2", "jpg2"],
  },
  "image/jpeg": {
    source: "iana",
    compressible: false,
    extensions: ["jpeg", "jpg", "jpe"],
  },
  "image/jph": {
    source: "iana",
    extensions: ["jph"],
  },
  "image/jphc": {
    source: "iana",
    extensions: ["jhc"],
  },
  "image/jpm": {
    source: "iana",
    compressible: false,
    extensions: ["jpm"],
  },
  "image/jpx": {
    source: "iana",
    compressible: false,
    extensions: ["jpx", "jpf"],
  },
  "image/jxr": {
    source: "iana",
    extensions: ["jxr"],
  },
  "image/jxra": {
    source: "iana",
    extensions: ["jxra"],
  },
  "image/jxrs": {
    source: "iana",
    extensions: ["jxrs"],
  },
  "image/jxsi": {
    source: "iana",
    extensions: ["jxsi"],
  },
  "image/jxss": {
    source: "iana",
    extensions: ["jxss"],
  },
  "image/ktx": {
    source: "iana",
    extensions: ["ktx"],
  },
  "image/naplps": {
    source: "iana",
  },
  "image/pjpeg": {
    compressible: false,
  },
  "image/png": {
    source: "iana",
    compressible: false,
    extensions: ["png"],
  },
  "image/prs.btif": {
    source: "iana",
    extensions: ["btif"],
  },
  "image/prs.pti": {
    source: "iana",
    extensions: ["pti"],
  },
  "image/pwg-raster": {
    source: "iana",
  },
  "image/sgi": {
    source: "apache",
    extensions: ["sgi"],
  },
  "image/svg+xml": {
    source: "iana",
    compressible: true,
    extensions: ["svg", "svgz"],
  },
  "image/t38": {
    source: "iana",
    extensions: ["t38"],
  },
  "image/tiff": {
    source: "iana",
    compressible: false,
    extensions: ["tif", "tiff"],
  },
  "image/tiff-fx": {
    source: "iana",
    extensions: ["tfx"],
  },
  "image/vnd.adobe.photoshop": {
    source: "iana",
    compressible: true,
    extensions: ["psd"],
  },
  "image/vnd.airzip.accelerator.azv": {
    source: "iana",
    extensions: ["azv"],
  },
  "image/vnd.cns.inf2": {
    source: "iana",
  },
  "image/vnd.dece.graphic": {
    source: "iana",
    extensions: ["uvi", "uvvi", "uvg", "uvvg"],
  },
  "image/vnd.djvu": {
    source: "iana",
    extensions: ["djvu", "djv"],
  },
  "image/vnd.dvb.subtitle": {
    source: "iana",
    extensions: ["sub"],
  },
  "image/vnd.dwg": {
    source: "iana",
    extensions: ["dwg"],
  },
  "image/vnd.dxf": {
    source: "iana",
    extensions: ["dxf"],
  },
  "image/vnd.fastbidsheet": {
    source: "iana",
    extensions: ["fbs"],
  },
  "image/vnd.fpx": {
    source: "iana",
    extensions: ["fpx"],
  },
  "image/vnd.fst": {
    source: "iana",
    extensions: ["fst"],
  },
  "image/vnd.fujixerox.edmics-mmr": {
    source: "iana",
    extensions: ["mmr"],
  },
  "image/vnd.fujixerox.edmics-rlc": {
    source: "iana",
    extensions: ["rlc"],
  },
  "image/vnd.globalgraphics.pgb": {
    source: "iana",
  },
  "image/vnd.microsoft.icon": {
    source: "iana",
    extensions: ["ico"],
  },
  "image/vnd.mix": {
    source: "iana",
  },
  "image/vnd.mozilla.apng": {
    source: "iana",
  },
  "image/vnd.ms-modi": {
    source: "iana",
    extensions: ["mdi"],
  },
  "image/vnd.ms-photo": {
    source: "apache",
    extensions: ["wdp"],
  },
  "image/vnd.net-fpx": {
    source: "iana",
    extensions: ["npx"],
  },
  "image/vnd.radiance": {
    source: "iana",
  },
  "image/vnd.sealed.png": {
    source: "iana",
  },
  "image/vnd.sealedmedia.softseal.gif": {
    source: "iana",
  },
  "image/vnd.sealedmedia.softseal.jpg": {
    source: "iana",
  },
  "image/vnd.svf": {
    source: "iana",
  },
  "image/vnd.tencent.tap": {
    source: "iana",
    extensions: ["tap"],
  },
  "image/vnd.valve.source.texture": {
    source: "iana",
    extensions: ["vtf"],
  },
  "image/vnd.wap.wbmp": {
    source: "iana",
    extensions: ["wbmp"],
  },
  "image/vnd.xiff": {
    source: "iana",
    extensions: ["xif"],
  },
  "image/vnd.zbrush.pcx": {
    source: "iana",
    extensions: ["pcx"],
  },
  "image/webp": {
    source: "apache",
    extensions: ["webp"],
  },
  "image/wmf": {
    source: "iana",
    extensions: ["wmf"],
  },
  "image/x-3ds": {
    source: "apache",
    extensions: ["3ds"],
  },
  "image/x-cmu-raster": {
    source: "apache",
    extensions: ["ras"],
  },
  "image/x-cmx": {
    source: "apache",
    extensions: ["cmx"],
  },
  "image/x-freehand": {
    source: "apache",
    extensions: ["fh", "fhc", "fh4", "fh5", "fh7"],
  },
  "image/x-icon": {
    source: "apache",
    compressible: true,
    extensions: ["ico"],
  },
  "image/x-jng": {
    source: "nginx",
    extensions: ["jng"],
  },
  "image/x-mrsid-image": {
    source: "apache",
    extensions: ["sid"],
  },
  "image/x-ms-bmp": {
    source: "nginx",
    compressible: true,
    extensions: ["bmp"],
  },
  "image/x-pcx": {
    source: "apache",
    extensions: ["pcx"],
  },
  "image/x-pict": {
    source: "apache",
    extensions: ["pic", "pct"],
  },
  "image/x-portable-anymap": {
    source: "apache",
    extensions: ["pnm"],
  },
  "image/x-portable-bitmap": {
    source: "apache",
    extensions: ["pbm"],
  },
  "image/x-portable-graymap": {
    source: "apache",
    extensions: ["pgm"],
  },
  "image/x-portable-pixmap": {
    source: "apache",
    extensions: ["ppm"],
  },
  "image/x-rgb": {
    source: "apache",
    extensions: ["rgb"],
  },
  "image/x-tga": {
    source: "apache",
    extensions: ["tga"],
  },
  "image/x-xbitmap": {
    source: "apache",
    extensions: ["xbm"],
  },
  "image/x-xcf": {
    compressible: false,
  },
  "image/x-xpixmap": {
    source: "apache",
    extensions: ["xpm"],
  },
  "image/x-xwindowdump": {
    source: "apache",
    extensions: ["xwd"],
  },
  "video/1d-interleaved-parityfec": {
    source: "iana",
  },
  "video/3gpp": {
    source: "iana",
    extensions: ["3gp", "3gpp"],
  },
  "video/3gpp-tt": {
    source: "iana",
  },
  "video/3gpp2": {
    source: "iana",
    extensions: ["3g2"],
  },
  "video/bmpeg": {
    source: "iana",
  },
  "video/bt656": {
    source: "iana",
  },
  "video/celb": {
    source: "iana",
  },
  "video/dv": {
    source: "iana",
  },
  "video/encaprtp": {
    source: "iana",
  },
  "video/flexfec": {
    source: "iana",
  },
  "video/h261": {
    source: "iana",
    extensions: ["h261"],
  },
  "video/h263": {
    source: "iana",
    extensions: ["h263"],
  },
  "video/h263-1998": {
    source: "iana",
  },
  "video/h263-2000": {
    source: "iana",
  },
  "video/h264": {
    source: "iana",
    extensions: ["h264"],
  },
  "video/h264-rcdo": {
    source: "iana",
  },
  "video/h264-svc": {
    source: "iana",
  },
  "video/h265": {
    source: "iana",
  },
  "video/iso.segment": {
    source: "iana",
  },
  "video/jpeg": {
    source: "iana",
    extensions: ["jpgv"],
  },
  "video/jpeg2000": {
    source: "iana",
  },
  "video/jpm": {
    source: "apache",
    extensions: ["jpm", "jpgm"],
  },
  "video/mj2": {
    source: "iana",
    extensions: ["mj2", "mjp2"],
  },
  "video/mp1s": {
    source: "iana",
  },
  "video/mp2p": {
    source: "iana",
  },
  "video/mp2t": {
    source: "iana",
    extensions: ["ts"],
  },
  "video/mp4": {
    source: "iana",
    compressible: false,
    extensions: ["mp4", "mp4v", "mpg4"],
  },
  "video/mp4v-es": {
    source: "iana",
  },
  "video/mpeg": {
    source: "iana",
    compressible: false,
    extensions: ["mpeg", "mpg", "mpe", "m1v", "m2v"],
  },
  "video/mpeg4-generic": {
    source: "iana",
  },
  "video/mpv": {
    source: "iana",
  },
  "video/nv": {
    source: "iana",
  },
  "video/ogg": {
    source: "iana",
    compressible: false,
    extensions: ["ogv"],
  },
  "video/parityfec": {
    source: "iana",
  },
  "video/pointer": {
    source: "iana",
  },
  "video/quicktime": {
    source: "iana",
    compressible: false,
    extensions: ["qt", "mov"],
  },
  "video/raptorfec": {
    source: "iana",
  },
  "video/raw": {
    source: "iana",
  },
  "video/rtp-enc-aescm128": {
    source: "iana",
  },
  "video/rtploopback": {
    source: "iana",
  },
  "video/rtx": {
    source: "iana",
  },
  "video/smpte291": {
    source: "iana",
  },
  "video/smpte292m": {
    source: "iana",
  },
  "video/ulpfec": {
    source: "iana",
  },
  "video/vc1": {
    source: "iana",
  },
  "video/vc2": {
    source: "iana",
  },
  "video/vnd.cctv": {
    source: "iana",
  },
  "video/vnd.dece.hd": {
    source: "iana",
    extensions: ["uvh", "uvvh"],
  },
  "video/vnd.dece.mobile": {
    source: "iana",
    extensions: ["uvm", "uvvm"],
  },
  "video/vnd.dece.mp4": {
    source: "iana",
  },
  "video/vnd.dece.pd": {
    source: "iana",
    extensions: ["uvp", "uvvp"],
  },
  "video/vnd.dece.sd": {
    source: "iana",
    extensions: ["uvs", "uvvs"],
  },
  "video/vnd.dece.video": {
    source: "iana",
    extensions: ["uvv", "uvvv"],
  },
  "video/vnd.directv.mpeg": {
    source: "iana",
  },
  "video/vnd.directv.mpeg-tts": {
    source: "iana",
  },
  "video/vnd.dlna.mpeg-tts": {
    source: "iana",
  },
  "video/vnd.dvb.file": {
    source: "iana",
    extensions: ["dvb"],
  },
  "video/vnd.fvt": {
    source: "iana",
    extensions: ["fvt"],
  },
  "video/vnd.hns.video": {
    source: "iana",
  },
  "video/vnd.iptvforum.1dparityfec-1010": {
    source: "iana",
  },
  "video/vnd.iptvforum.1dparityfec-2005": {
    source: "iana",
  },
  "video/vnd.iptvforum.2dparityfec-1010": {
    source: "iana",
  },
  "video/vnd.iptvforum.2dparityfec-2005": {
    source: "iana",
  },
  "video/vnd.iptvforum.ttsavc": {
    source: "iana",
  },
  "video/vnd.iptvforum.ttsmpeg2": {
    source: "iana",
  },
  "video/vnd.motorola.video": {
    source: "iana",
  },
  "video/vnd.motorola.videop": {
    source: "iana",
  },
  "video/vnd.mpegurl": {
    source: "iana",
    extensions: ["mxu", "m4u"],
  },
  "video/vnd.ms-playready.media.pyv": {
    source: "iana",
    extensions: ["pyv"],
  },
  "video/vnd.nokia.interleaved-multimedia": {
    source: "iana",
  },
  "video/vnd.nokia.mp4vr": {
    source: "iana",
  },
  "video/vnd.nokia.videovoip": {
    source: "iana",
  },
  "video/vnd.objectvideo": {
    source: "iana",
  },
  "video/vnd.radgamettools.bink": {
    source: "iana",
  },
  "video/vnd.radgamettools.smacker": {
    source: "iana",
  },
  "video/vnd.sealed.mpeg1": {
    source: "iana",
  },
  "video/vnd.sealed.mpeg4": {
    source: "iana",
  },
  "video/vnd.sealed.swf": {
    source: "iana",
  },
  "video/vnd.sealedmedia.softseal.mov": {
    source: "iana",
  },
  "video/vnd.uvvu.mp4": {
    source: "iana",
    extensions: ["uvu", "uvvu"],
  },
  "video/vnd.vivo": {
    source: "iana",
    extensions: ["viv"],
  },
  "video/vnd.youtube.yt": {
    source: "iana",
  },
  "video/vp8": {
    source: "iana",
  },
  "video/webm": {
    source: "apache",
    compressible: false,
    extensions: ["webm"],
  },
  "video/x-f4v": {
    source: "apache",
    extensions: ["f4v"],
  },
  "video/x-fli": {
    source: "apache",
    extensions: ["fli"],
  },
  "video/x-flv": {
    source: "apache",
    compressible: false,
    extensions: ["flv"],
  },
  "video/x-m4v": {
    source: "apache",
    extensions: ["m4v"],
  },
  "video/x-matroska": {
    source: "apache",
    compressible: false,
    extensions: ["mkv", "mk3d", "mks"],
  },
  "video/x-mng": {
    source: "apache",
    extensions: ["mng"],
  },
  "video/x-ms-asf": {
    source: "apache",
    extensions: ["asf", "asx"],
  },
  "video/x-ms-vob": {
    source: "apache",
    extensions: ["vob"],
  },
  "video/x-ms-wm": {
    source: "apache",
    extensions: ["wm"],
  },
  "video/x-ms-wmv": {
    source: "apache",
    compressible: false,
    extensions: ["wmv"],
  },
  "video/x-ms-wmx": {
    source: "apache",
    extensions: ["wmx"],
  },
  "video/x-ms-wvx": {
    source: "apache",
    extensions: ["wvx"],
  },
  "video/x-msvideo": {
    source: "apache",
    extensions: ["avi"],
  },
  "video/x-sgi-movie": {
    source: "apache",
    extensions: ["movie"],
  },
  "video/x-smv": {
    source: "apache",
    extensions: ["smv"],
  },
  "application/vnd.apple.pages": {
    source: "apache",
    extensions: ["pages"],
  },
  "application/vnd.apple.numbers": {
    source: "apache",
    extensions: ["numbers"],
  },
  "application/vnd.apple.keynote": {
    source: "apache",
    extensions: ["key"],
  },
};

export default MimeDb;
